var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row messageContainer requesters",attrs:{"id":"buyerCheckout"}},[_c('h4',[_vm._v("Ready to Buy?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('a',{staticClass:"btn",on:{"click":_vm.goToCheckout}},[_vm._v("Proceed to Payment")])])
}
var staticRenderFns = []

export { render, staticRenderFns }